<mat-expansion-panel class="mat-elevation-z1" [expanded]="expanded">
  <mat-expansion-panel-header style="background-color: whitesmoke;">
    <mat-panel-title class="avenir-font text-nowrap">
      {{ label }}
    </mat-panel-title>
    <mat-panel-description class="justify-content-end">
      <mat-icon [ngStyle]="{'color': minValue != min ?? maxValue != max ? '#9E81E4' : '#999'}">{{ iconName }}</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="pt-4">

      <!-- <mat-label class="avenir-font">{{ label }}</mat-label> -->
      <div class="custom-slider ms-3 ps-2 pe-3">
        <ngx-slider class="w-100"   [(value)]="minValue" [(highValue)]="maxValue" [options]="sliderOptions" (userChangeEnd)="onSliderChangeValue()"></ngx-slider>
      </div>

  </div>
</mat-expansion-panel>
